import { AllieIconProps } from '../../../components';

export const ArrowDownIcon: React.FC<AllieIconProps> = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
    <path
      d="M6.5 2.5V9.5M6.5 9.5L10 6M6.5 9.5L3 6"
      stroke="#D92D20"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
